// 自定义配置，参考 ./default/setting.config.js，需要自定义的属性在这里配置即可
module.exports = {
  theme: {
    color: '#13c2c2',
    mode: 'dark',
  },
  multiPage: true,
  asyncRoutes: false,
  animate: {
    disabled: true,                    //禁用动画，true:禁用，false:启用
    name: 'lightSpeed',
    direction: 'left'
  }
}
